import { type FunctionComponent } from 'react';
import Header from './Header';
import NotFound from '../NotFound';
import { useCurrentPortalId } from './hooks';
import * as _ from 'lodash';
import { NOT_FOUND } from '../../../shared/errors/errorMessage';

const OrganizationPortal: FunctionComponent = ({ children }) => {

  const { errors, value, isLoading } = useCurrentPortalId();

  if (!_.isEmpty(errors) && errors?.includes(NOT_FOUND)) {
    return (
      <NotFound />
    );
  }

  if (value && !isLoading) {
    return (
      <>
        <Header />
        { children }
      </>
    );
  }

  return (<></>)
};

export default OrganizationPortal;
